export default __webpack_public_path__ + "static/media/Snd_q3.effe7f2e.mp3";